import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function DespreHero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-brand-cream" data-id="element-1175">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-brand-gold/[0.08] to-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/4 animate-float pointer-events-none" data-id="element-1176" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1177">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-y-8 lg:gap-y-10 gap-x-12 lg:gap-x-20 lg:items-center" data-id="element-1178">
          {/* Badge + Name */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 lg:order-1 lg:col-start-1 lg:row-start-1 flex flex-col items-center lg:items-center text-center" data-id="element-1179">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-brand-gold/20 text-brand-gold text-xs font-bold uppercase tracking-wider mb-6 shadow-sm" data-id="element-1180">
              <Sparkles className="w-4 h-4" data-id="element-1181" />
              Dezvoltare Personală și Spirituală
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-[72px] leading-[1.1] font-bold text-brand-text text-balance" data-id="element-1182">
              Adrian Huniade
            </h1>
          </motion.div>

          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-2 lg:order-2 lg:col-start-2 lg:row-start-1 lg:row-span-3 relative w-full aspect-[4/5] max-w-[440px] mx-auto lg:ml-auto" data-id="element-1183">
            <div className="absolute inset-0 bg-brand-gold/30 rounded-[32px] blur-2xl transform translate-x-4 translate-y-4" data-id="element-1184" />
            <div className="absolute -top-12 -right-12 w-48 h-48 border-[1.5px] border-brand-gold/40 rounded-full border-b-transparent border-l-transparent rotate-45 -z-10" data-id="element-1185" />

            <div className="relative w-full h-full rounded-[32px] shadow-warm overflow-hidden border-4 border-white" data-id="element-1186">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="w-full h-full object-cover object-top" data-id="element-1187" />
            </div>
          </motion.div>

          {/* Specializations in elegant frame */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="order-3 lg:order-3 lg:col-start-1 lg:row-start-2 w-full max-w-xl mx-auto lg:mx-0" data-id="element-1188">
            <div className="relative rounded-2xl border border-brand-gold/30 bg-white/60 backdrop-blur-sm px-6 py-5 shadow-sm" data-id="element-1189">
              <div className="absolute -top-px left-1/2 -translate-x-1/2 w-16 h-1 bg-brand-gold rounded-full" data-id="element-1190" />
              <p className="font-subtitle font-medium text-base md:text-lg text-brand-text/90 leading-relaxed text-center" data-id="element-1191">
                Instructor Internațional Theta Healing® · Facilitator Heal Your
                Life · Consilier Dezvoltare Personală
              </p>
            </div>
          </motion.div>

          {/* About paragraph */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="order-4 lg:order-4 lg:col-start-1 lg:row-start-3 w-full max-w-xl mx-auto lg:mx-0" data-id="element-1192">
            <p className="font-subtitle italic text-lg md:text-xl text-brand-text/85 leading-relaxed text-left" data-id="element-1193">
              Nu sunt aici să îți promit soluții rapide sau rezultate peste
              noapte. Sunt aici să te ghidez într-un proces real, pas cu pas, cu
              multă iubire și răbdare. Fiecare om are în el lumina de care are
              nevoie. Rolul meu este să te ajut să o descoperi.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}